<template>
  <tbody v-if="transaction">
    <tr>
      <td style="width: 55px">
         <font-awesome-icon
           v-if="openTransaction"
           title="Match Process not yet complete."
           class="fa-lg has-text-warning"
           :icon="['fas', 'exclamation-triangle']"
         />
       </td>
      <td>
        <div class="is-flex flex-direction--column">
          <div class="is-flex">
            <router-link
              v-if="hasModule('PRSID:MATCH:HISTORY:VIEW')"
              :to="{ path: `/personId/individualMatch/${transaction.pidSubmissionId}/details` }"
              class="has-text-weight-bold"
            >
              {{ transaction.pidSubmissionId }}
            </router-link>
            <strong v-else
              class="is-flex"
            >
              {{ transaction.pidSubmissionId }}
            </strong>
          </div>
          <div class="is-flex">
            <span class="has-text-weight-grey">
              {{ transaction.pidBatch.submissionTypeCode }}
            </span>
          </div>
        </div>
      </td>
      <td :class="{'is-hidden-touch': isMobile}">
        <div class="is-flex flex-direction--column">
          <div>
            <router-link
              :to="{
                name: 'PIDistrictInfoDetails',
                params: { code: getDistrictCode },
              }"
              class="has-text-weight-bold has-text-primary"
              style="font-size:14px"
            >
              {{ getDistrictName }}
            </router-link>
            <span class="padding-left--small has-text-grey is-italic">
              ({{ getDistrictCode }})
            </span>
          </div>
          <div>
            <router-link
              :to="{
                name: 'PISchoolInfoDetails',
                params: {
                  districtCode: getDistrictCode,
                  schoolCode: getSchoolCode,
                },
              }"
              class="is-italic"
            >
              {{ getSchoolName }}
            </router-link>
            <span class="padding-left--small has-text-grey is-italic">
              ({{ getSchoolCode }})
            </span>
          </div>
        </div>
      </td>
      <td>
        <div class="is-flex flex-direction--column">
          <strong class="is-flex">
            {{
              new Intl.DateTimeFormat('en', {
                year:'numeric',
                month:'2-digit',
                day:'2-digit',
              })
              .format(new Date(transaction.pidBatch.createdDate))
            }}
          </strong>
          <span class="has-text-grey">
            {{
              new Intl.DateTimeFormat('en', {
                hour:'numeric',
                minute:'numeric',
              })
              .format(new Date(transaction.pidBatch.createdDate))
            }}
          </span>
        </div>
      </td>
      <td>
        <router-link
          v-if="hasModule('PRSID:MATCH:HISTORY:VIEW')"
          :to="{ path: `/personid/batch/${transaction.pidBatchId}/details` }"
          class="has-text-weight-bold"
        >
          {{ transaction.pidBatchId }}
        </router-link>
        <strong v-else
          class="is-flex"
        >
          {{ transaction.pidBatchId }}
        </strong>
      </td>
      <td :class="{'is-hidden-mobile': isMobile}">
        <pid-status-info-icon
          :header="false"
          :processStatus="transaction.transStatus"
        />
      </td>
      <td>
        <div class="is-flex flex-justify--end flex-align--center">
          <es-loader v-if="reloading" size="2x"/>
          <a
            v-else-if="isInternalAction"
            @click="handleInternalCall"
            @keypress="handleInternalCall"
            tabindex="0"
            role="button"
            :aria-label="action.text"
            :title="action.text"
            :class="{'is-hidden-mobile': isMobile}"
          >
            {{ action.text }}
          </a>
          <router-link :class="{'is-hidden-mobile': isMobile}" v-else-if="!action.isHidden" :to="action.link" :title="action.text || 'Actions'">
            {{ action.text }}
          </router-link>
          <a style="padding-left: 1rem" v-if="transactionCompletedMenu.length">
            <es-menu :setValues="transactionCompletedMenu"/>
          </a>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import EsLoader from '@/components/EsLoader.vue';
import EsMenu from '@/components/EsMenu.vue';
import PidStatusInfoIcon from '@/components/PidStatusInfoIcon.vue';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    PermissionManager,
  ],
  props: [
    'transObject',
    'isMobile',
  ],
  components: {
    EsLoader,
    EsMenu,
    PidStatusInfoIcon,
  },
  data() {
    return {
      transaction: null,
      reloading: null,
    };
  },
  async created() {
    try {
      await Promise.all([
        this.loadPidTransactionStatuses(),
      ]);
    } catch (err) {
      // do nothing
    }
    this.transaction = this.transObject;
  },

  computed: {
    ...mapGetters('lookups', [
      'pidNearMatchesTransGroup',
    ]),
    action() {
      if (this.pidNearMatchesTransGroup.list
        .map(s => s.id)
        .includes(this.transaction.transStatus)) {
        if (this.transaction.pidBatchId) {
          return {
            link: `/personid/nearMatches?pidSubmissionId=${this.transaction.pidSubmissionId}&pidBatchId=${this.transaction.pidBatchId}`,
            text: 'Resolve',
            isHidden: !this.hasModule('PRSID:MATCH:RESOLVENM:VIEW'),
          };
        }
        return {
          link: `/personid/nearMatches?pidSubmissionId=${this.transaction.pidSubmissionId}`,
          text: 'Resolve',
          isHidden: !this.hasModule('PRSID:MATCH:RESOLVENM:VIEW'),
        };
      }
      return {
        isHidden: true,
      };
    },
    isInternalAction() {
      return !!this.action.isInternal;
    },
    menuItems() {
      const items = [];
      if (this.pidNearMatchesTransGroup.list
        .map(s => s.id)
        .includes(this.transaction.transStatus)) {
        if (this.transaction.pidBatchId) {
          items.push({
            id: 0,
            description: 'Resolve',
            path: `/personid/nearMatches?pidSubmissionId=${this.transaction.pidSubmissionId}&pidBatchId=${this.transaction.pidBatchId}`,
            isHidden: !this.hasModule('PRSID:MATCH:RESOLVENM:VIEW'),
          });
        } else {
          items.push({
            id: 0,
            description: 'Resolve',
            path: `/personid/nearMatches?pidSubmissionId=${this.pidSubmissionId}`,
            isHidden: !this.hasModule('PRSID:MATCH:RESOLVENM:VIEW'),
          });
        }
      }
      items.push({
        id: 1,
        description: 'Download',
        path: `/personId/individualMatch/${this.transaction.pidSubmissionId}/download`,
        isHidden: !this.hasModule('PRSID:DWNLD:DOWNLOAD') || !this.isDownloadTypesAllowed,
      });
      items.push({
        id: 2,
        description: 'View Transaction Details',
        path: `/personId/individualMatch/${this.transaction.pidSubmissionId}/details`,
        isHidden: !this.hasModule('PRSID:MATCH:HISTORY:VIEW'),
      });
      return items;
    },
    openTransaction() {
      if (this.pidNearMatchesTransGroup) {
        return this.pidNearMatchesTransGroup.list.map(s => s.id).includes(this.transaction.transStatus);
      }
      return false;
    },
    transactionCompletedMenu() {
      return this.menuItems.filter(item => !item.isHidden);
    },
    getDistrictCode() {
      return this.transaction.pidBatchDistrictSchoolAssociation.length
        ? this.transaction.pidBatchDistrictSchoolAssociation[0].districtCode
        : this.transaction.districtCode;
    },
    getDistrictName() {
      return this.transaction.pidBatchDistrictSchoolAssociation.length
        ? this.transaction.pidBatchDistrictSchoolAssociation[0].district.location.name
        : this.transaction.districtName;
    },
    getSchoolCode() {
      return this.transaction.pidBatchDistrictSchoolAssociation.length
        ? this.transaction.pidBatchDistrictSchoolAssociation[0].schoolCode
        : this.transaction.schoolCode;
    },
    getSchoolName() {
      return this.transaction.pidBatchDistrictSchoolAssociation.length
        ? this.transaction.pidBatchDistrictSchoolAssociation[0].school.location.name
        : this.transaction.schoolName;
    },
    allowedExtractDownloadTypes() {
      return this.$store.state.propertiesModule.properties['PERSON-EXTRACT_DOWNLOAD_TYPES_ALLOWED'];
    },
    isDownloadTypesAllowed() {
      if (this.allowedExtractDownloadTypes) {
        return this.allowedExtractDownloadTypes.includes(this.transaction.pidBatch.submissionTypeCode);
      }
      return false;
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidTransactionStatuses',
    ]),
    handleInternalCall() {
      this[this.action.internalAction]();
    },
    async refreshTransactionRow() {
      try {
        this.reloading = true;
        const res = await axios.get(`personid/transactions/${this.pidSubmissionId}`);
        this.transaction = res.data;
      } catch (e) {
        // handle error
      }
      this.reloading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
  .padding-left--small
    padding-left: 0.25rem
</style>
